import {combineReducers} from 'redux'
import {connectRouter} from 'connected-react-router'
import components from './componentReducer'
import bltComponents from './bltReducer'
// import collectionApplicationReducer from './slice/collectionApplicationSlice'
// import collectorApplicationReducer from './slice/collectorApplicationSlice'
import primaryAgencyApplicationReducer from './slice/primaryAgencyApplicationSlice'
import additionalApplicationsReducer from './slice/additionalApplicationsSlice'
// import businessLicenceApplicationReducer from './slice/businessLicenceApplicationSlice'
import userAuthReducer from './slice/userAuthSlice'
import archiveApplicationReducer from './slice/archiveApplicationsSlice'

const rootReducer = (history) => combineReducers({
    router : connectRouter(history),
    components,
    primaryAgencyApplication : primaryAgencyApplicationReducer,
    additionalApplications : additionalApplicationsReducer,
    archiveApplications : archiveApplicationReducer,
    userAuth : userAuthReducer,
    bltComponents,
})

export default rootReducer
